<template>
    <div style="background-color: #fafafa;">
		<van-nav-bar title="购物车" left-arrow @click-left="onClickLeft"  fixed></van-nav-bar>
		<div class="psiConfirmCont">
			<van-pull-refresh v-model="refreshing" @refresh="onRefresh">
				<van-list v-model="loading" :finished="finished" @load="onLoad" class="listBox" finished-text="">
					<van-checkbox-group v-model="checkIds" ref="checkboxGroup">
					<div v-for="(item, index) in list" class="card" :key="item.uuid">
						<table class="layout">
							<tr style="width: 100%;" @click="selectCartItem(index)">
								<td rowspan="3" style="width: 10%" >
									<van-checkbox :name="item.uuid" v-if="multiple" ref="checkboxes" slot="left-icon"/>
								</td>
								<td></td>
								<td></td>
							</tr>
							<tr style="width: 100%;" >
								<td style="width: 40%;" @click="updateCartInfo(item.uuid, item.radId)">
									<van-image
											width="150"
											height="100"
											:src="item.imageUrl"
									/>
								</td>
								<td style="padding-left: 10px;" @click="selectCartItem(index)">
									<p>
										<span style="font-size: 16px; font-weight: bold">{{item.radIdname}}</span><br/>
										<span style="font-size: 12px;">中心距:{{item.centerSpacing}}</span><br/>
										<span style="font-size: 12px;">颜色:{{item.colorname}}</span><br/>
										<span style="font-size: 12px;">进水方式:{{item.waterFlowname}}</span><br/>
										<span style="font-size: 12px;">接口口径:{{item.calibername}}</span><br/>
										<span style="font-size: 12px;">每片单价(¥):{{item.price}}*片数：{{item.pieces}}</span><br/>
										<span style="font-size: 14px; font-weight: bold">¥{{item.unitedPrice}}</span><br/>
									</p>
								</td>
							</tr>
							<tr style="width: 100%;">
								<td style="width: 40%;text-align: right" class="content"><span>数量：</span></td>
								<td style="width: 50%;"><van-stepper v-model="item.quantity" integer theme="round" @change="onChange(item)"/></td>
							</tr>
						</table>
					</div>
					</van-checkbox-group>
				</van-list>
			</van-pull-refresh>
		</div>
		<div class="recordBox">
			<table style="width: 100%;margin-bottom: 3px;border-spacing:0;">
				<tr style="height:35px;padding: 0;">
					<td style="width: 20%;color:white;text-align: right;background-color: #555555;padding-left: 20px;"><van-checkbox v-model="isAll" icon-size="10px" @change="checkAll()">全选</van-checkbox></td>
					<td style="width: 30%;color:white;background-color: #555555;">合计:¥{{ amount }}</td>
					<td style="width: 20%;color:white;background-color: #333333;text-align: center;cursor: pointer;" @click="onClickRight">删除</td>
					<td style="width: 30%;background-color:#ee0a24;" ><van-button type="danger" native-type="button" size="large" @click="settleOrder()">下单</van-button></td>
				</tr>
			</table>
		</div>
		<van-popup v-model="showCustomerInfo" closeable position="bottom" :style="{ height: '30%' }"
				   :close-on-click-overlay="false" >
			<table class="layout">
				<tr>
					<td colspan="2">
						<van-field  v-model="customerName" type="text" placeholder="用户名称"/>
						<van-field  v-model="arrivalAddress" type="text" placeholder="安装地址"/>
						<van-field  v-model="arrivalMobile" type="text" placeholder="联系方式"/>
					</td>
				</tr>
				<tr>
					<td>
						<van-button type="default" size="large" @click="cancelSettleOrder()">取消</van-button>
					</td>
					<td>
						<van-button type="danger" size="large" @click="getIntoOrder()">确定</van-button>
					</td>
				</tr>
			</table>
		</van-popup>
    </div>
</template>

<script>
    import {Tab, Tabs, Field, Panel, Button, List, Image, Search, Popup, PullRefresh, NavBar, Stepper, Toast, Checkbox, CheckboxGroup, Dialog} from 'vant';
	import dealerOrderService from "../../service/dealerOrderService";
    import {formatDictionary} from "../../utils/dictionary";
	import moment from "moment";
	import {API_URL} from "../../common/config";
    export default {
        data: function () {
            return {
                list: [],
                loading: false,
                finished: false,
                pageIndex: 0,
                refreshing: false,
				multiple: true,
				checkIds:[],
				quantity: 0,
				amount: 0.0,
				isAll: false,
				groupId: "",
				imageUrl: API_URL + "/oa/common/attachment/showImage?id=",
				showCustomerInfo: false,
				customerName: "",
				arrivalAddress: "",
				arrivalMobile: ""
            }
        },
        components: {
            [Tab.name]: Tab,
            [Tabs.name]: Tabs,
            [Button.name]: Button,
            [PullRefresh.name]: PullRefresh,
            [Panel.name]: Panel,
            [List.name]: List,
            [Search.name]: Search,
            [Popup.name]: Popup,
            [Stepper.name]: Stepper,
            [Field.name]: Field,
			[NavBar.name]: NavBar,
			[Image.name]: Image,
			[Checkbox.name]: Checkbox,
			[CheckboxGroup.name]: CheckboxGroup
        },
		created: async function () {
			let resp = await dealerOrderService.getDealerInfo();
			if (resp.data.Status === "1" && resp.data.Data) {
				this.groupId = resp.data.Data.priceGroupId || "";
			}
		},
        methods: {
            async onLoad() {
                this.pageIndex++;
                let resp = await dealerOrderService.getSkuCartList(this.pageIndex);
                resp.data.Data.data.forEach(item => {
                    item.createTime = moment(item.createTime).format('YYYY-MM-DD');
					if(item.isSpecials && item.isSpecials.length > 22){
						let temp = item.isSpecials;
						item.isSpecials = temp.substring(0, 22);
						item.isSpecials += "...";
					}
                });
				resp.data.Data.data.forEach(item => {
					item.imageUrl = this.imageUrl + item.imageIds.split(",")[0];
				});
                formatDictionary(resp.data.Data.data, resp.data.Data.dictionary);
                this.loading = false;
                this.refreshing = false;
                this.list = [...this.list, ...resp.data.Data.data];
                this.finished = resp.data.Data.total <= this.list.length;
            },
            onRefresh() {
                this.finished = false;
                this.loading = true;
                this.pageIndex = 0;
                this.list = [];
                this.onLoad();
            },
			async onChange(item){
				let resp = await dealerOrderService.updateSkuCartInfo(item.uuid, item.quantity);
				if (resp.data.Status === "1"){
					this.getCartQuantity(this.checkIds.join(","));
				} else {
					Toast.fail(resp.data.Message);
				}
			},
			selectCartItem(index){
				this.$refs.checkboxes[index].toggle();
			},
			cancelSettleOrder(){
            	this.showCustomerInfo = false;
            	this.customerName = "";
            	this.arrivalAddress = "";
            	this.arrivalMobile = "";
			},
			settleOrder(){
				if(this.checkIds.length === 0){
					Toast.fail("请选择要下单的产品！");
					return;
				}
            	this.showCustomerInfo = true;
			},
			checkAll(){
            	if(this.isAll){
					this.$refs.checkboxGroup.toggleAll(true);
				}else{
					this.$refs.checkboxGroup.toggleAll();
				}
			},
			updateCartInfo(uuid, radId){
				this.$router.push({path:"radDetail",  query:{uuid: uuid, radId: radId, groupId: this.groupId, editType: "cart"}} );
			},
			async getCartQuantity(ids){
            	if(ids.length ===0){
					this.amount = 0.0;
					this.quantity = 0;
					return;
				}
				let resp = await dealerOrderService.getCartAmount(ids);
				if (resp.data.Status === "1") {
					this.amount = resp.data.Data || 0.0;
				}
				resp = await dealerOrderService.getCartQuantity(ids);
				if (resp.data.Status === "1") {
					this.quantity = resp.data.Data || 0;
				}
			},
			async getIntoOrder(){
				Toast.loading({
					duration:0,
					message: '处理中...',
					forbidClick: true,
				});
				let resp = await dealerOrderService.settleSkuOrder(this.customerName, this.arrivalAddress, this.arrivalMobile, this.checkIds.join(","));
				if (resp.data.Status === "1"){
					Toast.clear();
					this.showCustomerInfo = false;
					this.$router.push("radOrder");
				} else {
					Toast.clear();
					Toast.fail(resp.data.Message);
					this.showCustomerInfo = false;
					this.onRefresh();
				}
			},
			onClickLeft(){
				this.$router.push("radSku");
			},
			onClickRight(){
            	if(this.checkIds.length === 0){
					Toast.fail("请选择要删除的产品！");
					return;
				}
				Dialog.confirm({
					title: '',
					message: '确定要将选择的商品移出购物车吗？'
				}).then(() => {
					this.deleteCartItems();
				}).catch(() => {
					return;
				});
			},
			async deleteCartItems(){
				let resp = await dealerOrderService.deleteCartItemByIds(this.checkIds.join(","));
				if (resp.data.Status === "1"){
					Toast.success("删除成功！");
					this.quantity = 0;
					this.checkIds = [];
					this.isAll = false;
					this.onRefresh();
				} else {
					Toast.fail(resp.data.Message);
				}
			},
        },
		watch: {
        	 checkIds(){
        		this.getCartQuantity(this.checkIds.join(","));
			}
		}
    };

</script>
<style>
	.card p {
		margin:10px 0;
	}
	.card p>span:first-child {
		flex: 0 0 4rem;
		text-align: right;
		margin-right: 20px;
	}
	.van-pull-refresh__head{
		display: none;
	}
	.van-checkbox__label{
		color: white;
	}
	.recordBox {
		padding: 0.5rem 0;
		box-sizing: border-box;
		margin-top: 2rem;
		bottom:0;
		position:fixed;
		width: 100%;
	}
	.psiConfirmCont{
		width:100%;
		margin:0 auto;
		margin-top:100px;
		overflow: hidden;
		padding-bottom: 150px;
	}
</style>